import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import {
  Typography,
  Tab,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Tabs from '@material-ui/core/Tabs';
import SearchIcon from '@material-ui/icons/Search';

import { AppHeader, SelectCompanyBox, TabPanel } from 'components';
import CurrentBookingsListTable from './components/current-bookings-list/CurrentBookingsListTable';
import CancelledBookingsListTable from './components/cancelled-bookings-list/CancelledBookingsListTable';
import HistoryBookingsListTable from './components/history-bookings-list/HistoryBoookingListTable';

import SelectDropDown from '../../components/select-drop-down/SelectDropDown';

import useStyles from './styles';

function verticalTabProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const CURRENT_TAB_INDEX = 0;
const CANCELLED_TAB_INDEX = 1;
const HISTORY_TAB_INDEX = 2;

const BookingList = ({ location, businessOwner }) => {
  const classes = useStyles();
  const [t] = useTranslation();
  const history = useHistory();

  const [value, setValue] = React.useState(
    location.state ? location.state.tabNumber : 0
  );
  const [handledBookings, setHandledBookings] = React.useState('all');
  const [searchField, setSearchField] = React.useState(undefined);
  const [search, setSearch] = React.useState(undefined);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [historyQuery, setHistoryQuery] = React.useState('allBookings');
  const [currentQuery, setCurrentQuery] = React.useState(
    location.state ? location.state.sortedBy : 'allBookings'
  );

  const handleSearchField = e => {
    setSearchField(e.target.value);
  };

  const onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      setSearch(searchField);
    }
  };

  return (
    <div className={classes.root}>
      <AppHeader />

      {!businessOwner.selectedBusinessOwner.id && <SelectCompanyBox />}

      {businessOwner.selectedBusinessOwner.id && (
        <div className={classes.wrapper}>
          <div className={classes.toolbar}>
            <div className={classes.toolbarLeft}>
              <Typography variant="h2" className={classes.toolbarTitle}>
                {t('Bookings')}
              </Typography>
            </div>
            <div className={classes.toolbarSwitchers}>
              <Tabs
                indicatorColor="primary"
                value={value}
                onChange={handleChange}
              >
                <Tab
                  classes={{
                    root: classes.customTabRoot,
                    wrapper: classes.customTabWrapper,
                    selected: classes.selected,
                    textColorInherit: classes.textColorInheritCustom
                  }}
                  label={t('Current')}
                  {...verticalTabProps(CURRENT_TAB_INDEX)}
                />
                <Tab
                  classes={{
                    root: classes.customTabRoot,
                    wrapper: classes.customTabWrapper,
                    selected: classes.selected,
                    textColorInherit: classes.textColorInheritCustom
                  }}
                  label={t('Canceled')}
                  {...verticalTabProps(CANCELLED_TAB_INDEX)}
                />
                <Tab
                  classes={{
                    root: classes.customTabRoot,
                    wrapper: classes.customTabWrapper,
                    selected: classes.selected,
                    textColorInherit: classes.textColorInheritCustom
                  }}
                  label={t('History')}
                  {...verticalTabProps(CURRENT_TAB_INDEX)}
                />
              </Tabs>
            </div>
            <div className={classes.toolbarFilter}>
              <Typography className={classes.filterTitle}>
                {t('Filter by')}:
              </Typography>
              <FormControl className={classes.formControl}>
                {value === CANCELLED_TAB_INDEX && (
                  <SelectDropDown
                    value={handledBookings}
                    onChange={setHandledBookings}
                    items={[
                      {
                        value: 'all',
                        label: 'All bookings'
                      },
                      {
                        value: 'handled',
                        label: 'Handled'
                      },
                      {
                        value: 'notHandled',
                        label: 'Not handled'
                      }
                    ]}
                    className={classes.selectInput}
                  />
                )}
                {value !== CANCELLED_TAB_INDEX && (
                  <SelectDropDown
                    value={
                      value === CURRENT_TAB_INDEX ? currentQuery : historyQuery
                    }
                    onChange={
                      value === CURRENT_TAB_INDEX
                        ? setCurrentQuery
                        : setHistoryQuery
                    }
                    className={classes.selectInput}
                    items={[
                      {
                        value: 'allBookings',
                        label: 'All bookings'
                      },
                      {
                        value: 'accommodationsBookings',
                        label: 'Accommodations'
                      },
                      {
                        value: 'activitiesBookings',
                        label: 'Activities'
                      }
                    ]}
                  />
                )}
              </FormControl>
            </div>
            <div>
              <TextField
                classes={{
                  root: classes.searchField
                }}
                placeholder="Search..."
                variant="outlined"
                value={searchField}
                onChange={handleSearchField}
                onKeyDown={onKeyDownHandler}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      onClick={() => setSearch(searchField)}
                    >
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className={classes.toolbarRight}>
              <Button
                onClick={() => {
                  history.push(`/accommodations`);
                }}
                variant="outlined"
                color="primary"
                classes={{ root: classes.buttonRoot }}
              >
                {t('Book Accommodation')}
              </Button>
              <Button
                onClick={() => {
                  history.push(`/activities`);
                }}
                variant="outlined"
                color="primary"
                classes={{ root: classes.buttonRoot }}
              >
                {t('Book Activity')}
              </Button>
            </div>
          </div>
          <div className={classes.tabsRoot}>
            <TabPanel
              className={classes.tabContentWrapper}
              value={value}
              index={CURRENT_TAB_INDEX}
            >
              <CurrentBookingsListTable
                bookingsQueryType={currentQuery}
                search={search}
              />
            </TabPanel>
            <TabPanel
              className={classes.tabContentWrapper}
              value={value}
              index={CANCELLED_TAB_INDEX}
            >
              <CancelledBookingsListTable
                handledStatus={handledBookings}
                search={search}
              />
            </TabPanel>
            <TabPanel
              className={classes.tabContentWrapper}
              value={value}
              index={HISTORY_TAB_INDEX}
            >
              <HistoryBookingsListTable
                bookingsQueryType={historyQuery}
                search={search}
              />
            </TabPanel>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(BookingList);
